/**
 * Shared pack ATC helpers for all pack-bundle*.js (product-pack).
 * Keeps .multiple-add-to-cart inner structure (price + status) in sync without using innerHTML on the root.
 */
(function (window) {
  'use strict';

  function compositionKey(parts) {
    return parts
      .map(function (p) {
        return String(p)
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9-]/g, '');
      })
      .filter(Boolean)
      .join(' / ');
  }

  function normalizeOptionValue(val) {
    return String(val || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getOptionName(opt) {
    if (opt == null) return '';
    return (typeof opt === 'object' && opt.name != null ? opt.name : String(opt)).toLowerCase().trim();
  }

  /**
   * Price Intelligems is testing for a variant, in cents, falling back to the catalog price
   * when Intelligems has not loaded or the variant is not part of a running test.
   * igData reports dollars; every caller here works in cents.
   */
  function intelligemsPriceCents(variantId, fallbackCents) {
    var price =
      window.igData &&
      window.igData.price &&
      typeof window.igData.price.getPriceByVariantId === 'function'
        ? parseFloat(window.igData.price.getPriceByVariantId(variantId))
        : NaN;
    if (!isFinite(price) || price <= 0) return fallbackCents;
    return Math.round(price * 100);
  }

  function intelligemsCompareAtCents(variantId, fallbackCents) {
    var compareAt =
      window.igData &&
      window.igData.price &&
      typeof window.igData.price.getComparePriceByVariantId === 'function'
        ? parseFloat(window.igData.price.getComparePriceByVariantId(variantId))
        : NaN;
    if (!isFinite(compareAt) || compareAt <= 0) return fallbackCents;
    return Math.round(compareAt * 100);
  }

  function getPriceFromColorSetForPack(ctx) {
    var packSize = ctx.querySelector('.pack-size__wrapper input:checked');
    if (!packSize || packSize.value === '1') return null;
    var colorSets = document.querySelectorAll(
      '.color-set__wrapper:not(.hidden) input:checked + label .color-set__sizes'
    );
    if (!colorSets.length) return null;
    var totalPrice = 0;
    var hasValidPrice = false;
    colorSets.forEach(function (colorSet) {
      var variants = Array.from(colorSet.querySelectorAll('.variant__size'));
      if (!variants.length) return;
      var variant =
        variants.find(function (v) {
          return parseInt(v.getAttribute('quantity'), 10) >= 5;
        }) || variants[0];
      var price = parseFloat(variant.getAttribute('price')) / 100;
      var qty = parseInt(variant.getAttribute('item-qty'), 10) || 1;
      if (price > 0) {
        totalPrice += price * qty;
        hasValidPrice = true;
      }
    });
    if (!hasValidPrice) return null;
    var discount = parseFloat(packSize.getAttribute('discount')) || 0;
    return totalPrice - (totalPrice * discount) / 100;
  }

  function getOriginalPackPriceForSelectedColorOnly(ctx) {
    var packSize = ctx.querySelector('.pack-size__wrapper input:checked');
    if (!packSize || packSize.value === '1' || !ctx.currentProduct || !ctx.currentProduct.variants || !ctx.currentProduct.variants.length)
      return null;
    var colorHeader = ctx.querySelector('.color_picker-header p span');
    var headerText = colorHeader ? colorHeader.textContent.trim() : '';
    if (!headerText) return null;
    var parts = headerText.split(/\s*\/\s*/).map(function (s) {
      return s.trim();
    }).filter(Boolean);
    var compositionFromDom = compositionKey(parts);
    if (!compositionFromDom || compositionFromDom.indexOf('productoptionvaluedrop') !== -1) return null;
    var options = ctx.currentProduct.options || [];
    var sizeIndex = options.findIndex(function (o) {
      return getOptionName(o) === 'size';
    });
    var compIndex = sizeIndex === 0 ? 1 : 0;
    if (sizeIndex < 0 || compIndex < 0) return null;
    var variant = ctx.currentProduct.variants.find(function (v) {
      if (!v.options || v.options.length < 2) return false;
      var variantComp = v.options[compIndex];
      var variantCompKey =
        typeof variantComp === 'string' && variantComp.indexOf('/') !== -1
          ? compositionKey(variantComp.split('/').map(function (s) {
              return s.trim();
            }))
          : compositionKey([variantComp]);
      return variantCompKey === compositionFromDom;
    });
    if (!variant) return null;
    var discount = parseFloat(packSize.getAttribute('discount')) || 0;
    var packSizeNum = parseInt(packSize.value, 10) || 1;
    var unitPrice = intelligemsPriceCents(variant.id, variant.price) / 100;
    var total = unitPrice * packSizeNum;
    return total - (total * discount) / 100;
  }

  function setAtcBtnText(ctx, text) {
    var btn = ctx.atcBtn;
    if (!btn) return;
    var textEl = btn.querySelector('.addtocart-button-text');
    if (textEl) {
      textEl.textContent = text;
    } else {
      btn.textContent = text;
    }
  }

  function setAtcBtnPrice(ctx, price, statusText, opts) {
    var visible = opts && opts.visible === true;
    var btn = ctx.atcBtn;
    if (!btn) return;
    var priceWrapper = btn.querySelector('.addtocart-button-price-wrapper');
    var priceEl = btn.querySelector('.addtocart-button-price');
    var compareEl = btn.querySelector('.addtocart-button-compare-price');
    var statusEl = btn.querySelector('.addtocart-button-status');
    if (!priceWrapper || !priceEl) return;
    if (price != null) {
      var currencySymbol = window.theme && window.theme.cart_currency_symbol ? window.theme.cart_currency_symbol : '$';
      var shopCurrency = window.theme && window.theme.shop_currency ? window.theme.shop_currency : '';
      priceEl.textContent = (currencySymbol + Shopify.formatMoneyAmmount(price) + ' ' + shopCurrency).trim();
      if (compareEl) {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
      priceWrapper.style.display = visible ? 'inline' : 'none';
      if (statusEl) {
        if (statusText) statusEl.textContent = statusText;
        statusEl.style.display = visible && statusText ? '' : 'none';
      }
    } else {
      // Keep the last price in the DOM; only hide it. The text must stay in the HTML
      // so it's available when it should be shown again (don't wipe priceEl/compareEl).
      priceWrapper.style.display = 'none';
      if (compareEl) compareEl.style.display = 'none';
      if (statusEl) {
        if (statusText) statusEl.textContent = statusText;
        statusEl.style.display = 'none';
      }
    }
  }

  function getPackAtcDisplayPrice(ctx) {
    if (ctx._atcPackPrice != null) return ctx._atcPackPrice;
    return getOriginalPackPriceForSelectedColorOnly(ctx) ?? getPriceFromColorSetForPack(ctx);
  }

  function syncPackAtcButtonPriceFromStore(ctx) {
    // Always write the pack price into the ATC button using the same value the pre-order
    // flow uses (getPackAtcDisplayPrice). Kept hidden (visible:false): the price is loaded
    // into the DOM but not shown, so no extra Liquid/section changes are needed.
    var amount = getPackAtcDisplayPrice(ctx);
    if (amount != null) {
      setAtcBtnPrice(ctx, amount, 'In Stock. Ready to Ship.', { visible: false });
    } else {
      setAtcBtnPrice(ctx, null, null, { visible: false });
    }
  }

  window.PackAtcSync = {
    compositionKey: compositionKey,
    normalizeOptionValue: normalizeOptionValue,
    getOptionName: getOptionName,
    intelligemsPriceCents: intelligemsPriceCents,
    intelligemsCompareAtCents: intelligemsCompareAtCents,
    getPriceFromColorSetForPack: getPriceFromColorSetForPack,
    getOriginalPackPriceForSelectedColorOnly: getOriginalPackPriceForSelectedColorOnly,
    setAtcBtnText: setAtcBtnText,
    setAtcBtnPrice: setAtcBtnPrice,
    getPackAtcDisplayPrice: getPackAtcDisplayPrice,
    syncPackAtcButtonPriceFromStore: syncPackAtcButtonPriceFromStore,
  };
})(window);
